import { useEffect, useRef, useState } from "react";
import WithAuth from "../../hoc/WithAuth";
import { ImportOutlined } from "@ant-design/icons";
import Papa from "papaparse";
import { Collapse, CollapseProps, Table } from "antd";
import { ExpandIconPosition } from "antd/es/collapse/Collapse";

type farmerType = {
  id: string;
  fullName: string;
  phoneNo: string;
  gender: string;
  birthDate: string;
  accountNumber: string;
  maritalStatus: string;
  tinNo: string;
  spouseTinNo: string;
  region: string;
  zone: string;
  woreda: string;
  kebele: string;
  houseNo: string;
  kebeleId: string;
};

const customersColumn = [
  { dataIndex: "fullName", title: "Full name" },
  { dataIndex: "birthDate", title: "Birth date" },
  { dataIndex: "gender", title: "Gender" },
  { dataIndex: "maritalStatus", title: "Marital status" },
  { dataIndex: "kebeleId", title: "Kebele Id" },
  { dataIndex: "tinNo", title: "TIN" },
  { dataIndex: "spouseTinNo", title: "Spouse TIN" },
  { dataIndex: "accountNumber", title: "Account No." },

  {
    dataIndex: "region",
    title: "Region",
    render: (region: string, record: farmerType) => (
      <div className="flex flex-col">
        <div>{`${region}, ${record.zone}, ${record.woreda}`}</div>
        <div>{`${record.kebele}, ${record.houseNo}`}</div>
      </div>
    ),
  },
  { dataIndex: "zone", title: "Zone" },
  { dataIndex: "woreda", title: "Woreda" },
  { dataIndex: "kebele", title: "Kebele" },
  { dataIndex: "houseNo", title: "HouseNo" },
];
function ImportCustomers() {
  const [customerData, setCustomerData] = useState<farmerType[]>([]);
  const customerDataRef = useRef<HTMLInputElement>(null);
  const [file, setFile] = useState<File>();
  const [error, setError] = useState("");
  const allowedExtensions = ["csv"];

  const [expandIconPosition, setExpandIconPosition] =
    useState<ExpandIconPosition>("start");

  const onPositionChange = (newExpandIconPosition: ExpandIconPosition) => {
    setExpandIconPosition(newExpandIconPosition);
  };

  const inputFileControlHandler = () => {
    if (customerDataRef && customerDataRef.current) {
      customerDataRef.current.click();
    }
  };

  useEffect(() => {
    if (file) {
      const reader = new FileReader();
      reader.onload = async (e: any) => {
        if (e.target && e.target.result) {
          const csv = Papa.parse(e.target.result, {
            header: true,
          });
          const parsedData = csv?.data;
          const _farmers: farmerType[] = parsedData.map((item: any) => {
            return {
              id: item.id,
              fullName: item.fullName,
              phoneNo: item.phoneNo,
              gender: item.gender,
              birthDate: item.birthDate,
              accountNumber: item.accountNumber,
              maritalStatus: item.maritalStatus,
              tinNo: item.tinNo,
              spouseTinNo: item.spouseTinNo,
              region: item.region,
              zone: item.zone,
              woreda: item.woreda,
              kebele: item.kebele,
              houseNo: item.houseNo,
              kebeleId: item.kebeleId,
            };
          });

          setCustomerData(_farmers);
          // const rows = Object.keys(parsedData[0]);

          // const columns = Object.values(parsedData[0]);
          // const res = rows.reduce((acc, e, i) => {
          //     return [...acc, [[e], columns[i]]];
          // }, []);
          // setData(res);
        }
      };
      reader.readAsText(file);
    }
  }, [file]);

  const handleImport = (e: any) => {
    const inputFile = e.target.files[0];

    const fileExtension = inputFile?.type.split("/")[1];
    if (fileExtension) {
      if (!allowedExtensions.includes(fileExtension.toLowerCase())) {
        setError("Please input a csv file");
        return;
      }

      setFile(inputFile);
    }
  };

  const items: CollapseProps["items"] = [
    {
      key: "1",
      label: "Customers data",
      children: (
        <div>
          <Table dataSource={customerData} columns={customersColumn} />
        </div>
      ),
      extra: (
        <ImportOutlined
          onClick={(e) => {
            e.stopPropagation();
            inputFileControlHandler();
          }}
        />
      ),
    },
  ];

  const ImportControl = () => {
    return (
      <div
        onClick={inputFileControlHandler}
        className="w-1/2 h-[200px] cursor-pointer flex flex-col justify-center items-center gap-4 border-dashed border-white border-2 rounded-xl"
      >
        <input
          type="file"
          id="customerData"
          onChange={handleImport}
          ref={customerDataRef}
          className="hidden"
        />
        <p className="ant-upload-drag-icon">
          <ImportOutlined className="text-white text-4xl" />
        </p>
        <p className="text-white text-3xl">
          Click here to import customer's data
        </p>
        <p className="text-white text-xl">Supported file *.CSV</p>
      </div>
    );
  };

  return (
    <div
      className="w-full flex justify-center pt-20"
      style={{ height: "100vh" }}
    >
      <input
        type="file"
        id="file"
        onChange={handleImport}
        ref={customerDataRef}
        className="hidden"
      />
      <div className="w-full flex flex-col gap-4">
        <Collapse
          className="w-full"
          defaultActiveKey={["1"]}
          // onChange={onChange}
          expandIconPosition={expandIconPosition}
          items={items}
        />
      </div>
    </div>
  );
}

export default WithAuth(ImportCustomers);
